export default "/images/490b13b01546ab7236669237976f3607.avif";